import { Textarea, UIText3 } from '@cian/ui-kit';
import * as React from 'react';
import { debounce } from '@cian/newbuilding-utils';
import { useDispatch, useSelector } from 'react-redux';

import { setProsRating } from '../../../actions/newReview';
import { TextareaReview } from '../../../components/NewReviewModal/parts/NewReviewModalReview/parts/Textarea';
import { getPros } from '../../../selectors/newReview';
import { REVIEWS_PROS_AND_CONS_MAX_LENGTH } from '../../../constants/reviews';

export const ProsContainer = (): React.JSX.Element => {
  const dispatch = useDispatch();
  const initialValue = useSelector(getPros) || '';
  const [value, setValue] = React.useState(initialValue);
  const [counter, setCounter] = React.useState(0);

  const setProsRatingDebounced = debounce(200, nextValue => dispatch(setProsRating(nextValue)));

  const onChange = React.useCallback(
    (_event: React.ChangeEvent<HTMLTextAreaElement>, nextValue: string) => {
      const counter = nextValue.length;
      if (counter <= REVIEWS_PROS_AND_CONS_MAX_LENGTH) {
        setCounter(nextValue.length);
        setValue(nextValue);
        setProsRatingDebounced(nextValue);
      }
    },
    [setValue, setProsRatingDebounced, setCounter],
  );

  return (
    <TextareaReview
      title="Плюсы"
      textarea={
        <Textarea
          onChange={onChange}
          value={value}
          minRows={5}
          maxRows={8}
          placeholder="Совсем рядом есть гипермаркет"
        />
      }
      counter={<UIText3 color="gray40_100">{`${counter}/${REVIEWS_PROS_AND_CONS_MAX_LENGTH}`}</UIText3>}
    />
  );
};
